import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {type IPerson} from '../schema';

/**
 * `getPersonById` request params
 * (what is used to send to server)
 */
export interface GetPersonByIdRequestOptions {
	id: IPerson['id'];
}

/**
 * `getPersonById` request
 * (what gets sent to the server)
 */
export type GetPersonByIdRequest = [GetPersonByIdRequestOptions['id']];

/**
 * `getPersonById` response
 * (what comes back from the server)
 */
export type GetPersonByIdResponse = SuccessResponse<GetPersonByIdResult>;

/**
 * `getPersonById` result
 * (what is utilized from the server response)
 */
export type GetPersonByIdResult = IPerson;

export const getPersonByIdEndpoint = 'getPersonById';

/**
 * Get person
 * @param fetchParams Fetch params
 * @returns Person
 */
export const getPersonById = async (
	{id}: GetPersonByIdRequestOptions,
	signal?: AbortSignal,
): Promise<GetPersonByIdResult> => {
	const client = NetxQueryClient();

	const requestParams: GetPersonByIdRequest = [id];

	return client
		.post<GetPersonByIdResponse>(getPersonByIdEndpoint, requestParams, {signal})
		.then(getResponseResults);
};

export default getPersonById;
